<template>
  <simple-button
    v-p-t="20"
    v-p-b="20"
    v-f-size="'14px'"
    v-color:violet
    variant="transparent"
    @click="handleClick"
  >
    <base-icon v-m-r="10" name="arrows_circle-arrow-left-curved" />
    <span v-text="$t('common.refund')" />
  </simple-button>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'RefundButton',
  components: {
    SimpleButton,
  },
  props: {
    publicId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      EVENT_BUS.$emit('REFUND_CONFIRM', this.publicId);
    },
  },
};
</script>
